import { Link } from "react-router-dom";

import { getRuntimeConfig } from "@/config/runtimeConfig";
import { UserMenu } from "./UserMenu";

type Props = {
  query: string;
  onQueryChange: (q: string) => void;
};

export function Header({ query, onQueryChange }: Props) {
  const cfg = getRuntimeConfig();

  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-7xl items-center gap-4 px-4">
        <Link to="/myapps" className="flex items-center gap-2">
          <LogoMark />
          <div className="hidden text-sm font-semibold text-slate-900 sm:block">
            {cfg.portalTitle}
          </div>
          <div className="hidden text-xs text-slate-500 md:block">
            · {cfg.companyName}
          </div>
        </Link>

        <div className="flex-1">
          <div className="mx-auto flex max-w-xl items-center rounded-full border border-slate-200 bg-slate-50 px-3 focus-within:border-brand-500 focus-within:bg-white">
            <svg
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-4 w-4 text-slate-400"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M9 3a6 6 0 104.472 10.03l3.249 3.248a.75.75 0 101.06-1.06l-3.248-3.25A6 6 0 009 3zm-4.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z"
                clipRule="evenodd"
              />
            </svg>
            <input
              type="search"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="Search apps"
              className="w-full bg-transparent py-2 pl-2 text-sm text-slate-800 placeholder-slate-400 focus:outline-none"
              aria-label="Search apps"
            />
          </div>
        </div>

        <UserMenu />
      </div>
    </header>
  );
}

function LogoMark() {
  return (
    <div
      className="grid h-8 w-8 grid-cols-2 gap-0.5 rounded bg-brand-500 p-1"
      aria-hidden="true"
    >
      <span className="rounded-sm bg-white" />
      <span className="rounded-sm bg-white/80" />
      <span className="rounded-sm bg-white/80" />
      <span className="rounded-sm bg-white/60" />
    </div>
  );
}
